var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87533 7.99984C6.87533 6.27395 8.27444 4.87484 10.0003 4.87484C11.7262 4.87484 13.1253 6.27395 13.1253 7.99984C13.1253 9.72573 11.7262 11.1248 10.0003 11.1248C8.27444 11.1248 6.87533 9.72573 6.87533 7.99984ZM10.0003 6.12484C8.96479 6.12484 8.12533 6.9643 8.12533 7.99984C8.12533 9.03537 8.96479 9.87484 10.0003 9.87484C11.0359 9.87484 11.8753 9.03537 11.8753 7.99984C11.8753 6.9643 11.0359 6.12484 10.0003 6.12484Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04199 10.4998C1.04199 5.55229 5.05277 1.5415 10.0003 1.5415C14.9479 1.5415 18.9587 5.55229 18.9587 10.4998C18.9587 15.4474 14.9479 19.4582 10.0003 19.4582C5.05277 19.4582 1.04199 15.4474 1.04199 10.4998ZM10.0003 2.7915C5.74313 2.7915 2.29199 6.24264 2.29199 10.4998C2.29199 12.6212 3.14888 14.5423 4.53541 15.9361C4.68574 15.1252 4.98111 14.3606 5.57397 13.7458C6.46076 12.8261 7.8788 12.3748 10.0003 12.3748C12.1218 12.3748 13.5398 12.8261 14.4266 13.7458C15.0195 14.3606 15.3148 15.1252 15.4652 15.9362C16.8517 14.5424 17.7087 12.6212 17.7087 10.4998C17.7087 6.24264 14.2575 2.7915 10.0003 2.7915ZM14.3284 16.8793C14.2435 15.8694 14.0242 15.1293 13.5268 14.6134C12.9856 14.0521 11.9827 13.6248 10.0003 13.6248C8.01782 13.6248 7.015 14.0521 6.47378 14.6134C5.97638 15.1292 5.75708 15.8694 5.67218 16.8793C6.90603 17.718 8.39594 18.2082 10.0003 18.2082C11.6047 18.2082 13.0946 17.718 14.3284 16.8793Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircleIcon);
export default __webpack_public_path__ + "static/media/AccountCircleIcon.dadcb31edd1525bc94c8a4eb952f433b.svg";
export { ForwardRef as ReactComponent };